import { Directive, HostListener, Input, Output } from '@angular/core'
import { EventEmitter } from '@angular/core'

@Directive ({
    selector: '[gdShowOnChange]',
    standalone: false
})

export class GdShowOnChangeDirective {
    constructor() {
    }
    
    @Output() gdValueChange: EventEmitter<string> = new EventEmitter<string>();
    @Input('gdShowOnChange') gdFieldId: string;
    
    @HostListener('gdModelChange') onModelChange() { 
        setTimeout(() => {
            this.gdValueChange.emit(this.gdFieldId);            
        },0);
    }
}